(function () {
    'use strict';

    angular
		.module('glossaryTermModule')
		.directive('glossaryTerm', directive);

    directive.$inject = ['boxTmplScope',
						 'boxTmplHtml',
						 'boxTmplLinkFn'];

    function directive(boxTmplScope,
					   boxTmplHtml,
					   boxTmplLinkFn) {
        var directiveScope = _.clone(boxTmplScope);
        directiveScope.highlight = '=';

        return {
            scope: directiveScope,
            template: boxTmplHtml,
            controller: ['$scope',
						 '$controller','permissionService',
						 function ($scope,
						 		   $controller,permissionService) {
						     // Box template

						     $scope.canEdit = permissionService.hasPermission('ProceduresManagement', 'GlossaryTerm', 'Edit');

						     // Page is dirty
						     $scope.ctxtCtrl = {};
						     $scope.ctxtCtrl.needSaveChanges = false;

						     $scope.pageIsDirty = function () {
						         $scope.ctxtCtrl.needSaveChanges = true;
						         $rootScope.$broadcast('page-is-dirty');
						     };
						     $scope.pageIsNotDirty = function () {
						         $scope.ctxtCtrl.needSaveChanges = false;
						         $rootScope.$broadcast('page-is-not-dirty');
						     };

						     $scope.baseTemplatePath = '/app/shared/glossaryTerm/glossaryTerm.[Template].tpl.html';
						     $controller('BoxTmplController', { $scope: $scope });
						 }],
            link: function (scope, elem, attrs) {
                boxTmplLinkFn(scope, elem, attrs);
            }
        }
    }
})();